
namespace TabAurous.Master {

    @Serenity.Decorators.registerClass()
    export class EmployeeMasterDialog extends _Ext.DialogBase<EmployeeMasterRow, any> {
        protected getFormKey() { return EmployeeMasterForm.formKey; }
        protected getIdProperty() { return EmployeeMasterRow.idProperty; }
        protected getLocalTextPrefix() { return EmployeeMasterRow.localTextPrefix; }
        protected getNameProperty() { return EmployeeMasterRow.nameProperty; }
        protected getService() { return EmployeeMasterService.baseUrl; }
        protected getDeletePermission() { return EmployeeMasterRow.deletePermission; }
        protected getInsertPermission() { return EmployeeMasterRow.insertPermission; }
        protected getUpdatePermission() { return EmployeeMasterRow.updatePermission; }
        protected useViewMode() { return true; }
        protected get_ExtDialogOptions() {
            let options = super.get_ExtDialogOptions();
            options.ShowSaveAndNewButtonInToolbar = true;
            options.AutoFitContentArea = false;
            return options;
        }

        protected form = new EmployeeMasterForm(this.idPrefix);

    }
}